var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCamera = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  style: {
    background: "#14202c"
  },
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M11.984 18q1.368 0 2.52-.672a5 5 0 0 0 1.824-1.824 4.9 4.9 0 0 0 .672-2.52q0-1.368-.672-2.52a5 5 0 0 0-1.824-1.824 4.9 4.9 0 0 0-2.52-.672q-1.368 0-2.52.672a5 5 0 0 0-1.824 1.824 4.9 4.9 0 0 0-.672 2.52q0 1.368.672 2.52a5 5 0 0 0 1.824 1.824 4.9 4.9 0 0 0 2.52.672m-3-15h6l1.824 1.968H20q.816 0 1.392.6t.576 1.416v12q0 .816-.576 1.416T20 21H3.968a1.86 1.86 0 0 1-1.392-.6A1.98 1.98 0 0 1 2 18.984v-12q0-.816.576-1.416t1.392-.6H7.16zm-.192 9.984q0-.864.432-1.596a3.25 3.25 0 0 1 1.164-1.164 3.1 3.1 0 0 1 1.596-.432q.864 0 1.596.432t1.164 1.164.432 1.596-.432 1.596a3.25 3.25 0 0 1-1.164 1.164 3.1 3.1 0 0 1-1.596.432 3.1 3.1 0 0 1-1.596-.432 3.25 3.25 0 0 1-1.164-1.164 3.1 3.1 0 0 1-.432-1.596"
})));
export default SvgCamera;